module.exports = __webpack_public_path__ + "media/images/flags/64/Northern-Cyprus-fa873ace51fc38fcd5683d0f6b395ce8.png";